<template>

    <div>

        <AnchorInput :options="options"/>

        <MarginInput :options="options"/>

        <ColorsInput label="Achtergrondkleur"
                     instruction="Bepaal hier de achtergrondkleur van het gehele blok."
                     :colors="colors"
                     :options="options"
                     options-property="color"/>

    </div>

</template>

<script>

import AnchorInput from "./AnchorInput";
import MarginInput from "./MarginInput";
import ColorsInput from "../../../../js/common/canvas/editor/canvas/document/editors/inputs/ColorsInput";

export default {

    components: {
        ColorsInput,
        AnchorInput,
        MarginInput,
    },

    props: {
        options: Object,
    },

    computed: {

        colors() {
            // Grab tailwind config
            let tailwindConfig = require('./../../../../../../../../tailwind.config.js');

            // Get colors from config
            let tailwindConfigColors = Object.values(tailwindConfig.theme.extend.colors.palette);

            // Add standard additional colors
            tailwindConfigColors = [
                'transparent',
                '#fff',
                '#000',
                ...tailwindConfigColors,
            ];

            // Return colors
            return tailwindConfigColors;
        },

    },

}

</script>
